import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconFlipHorizontal';
/** Renders an SVG icon. */
const SvgFlipHorizontal = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M28 22.586c0 1.782-2.154 2.674-3.414 1.414l-5-5A2 2 0 0 1 19 17.586v-3.172A2 2 0 0 1 19.586 13l5-5C25.846 6.74 28 7.632 28 9.414zM26 9.414l-5 5v3.172l5 5zm-15 8.172v-3.172l-5-5v13.172zM4 9.414C4 7.632 6.154 6.74 7.414 8l5 5A2 2 0 0 1 13 14.414v3.172A2 2 0 0 1 12.414 19l-5 5C6.154 25.26 4 24.368 4 22.586zm13-2.581a1 1 0 1 1-2 0V5a1 1 0 1 1 2 0zm0 7.334a1 1 0 0 1-2 0V10.5a1 1 0 1 1 2 0zm0 7.333a1 1 0 1 1-2 0v-3.667a1 1 0 0 1 2 0zm0 5.5a1 1 0 1 1-2 0v-1.833a1 1 0 1 1 2 0z"
      />
    </svg>
  );
};
SvgFlipHorizontal.displayName = displayName;
export default SvgFlipHorizontal;
